export enum MeetingStatusEnum {
  InProgress = 1,
  UpComming = 2,
  Completed = 3,
  Suspended = 4,
  Canceled = 5
}
export enum TaskStatusEnum {
  New = 1,
  InProgress = 2,
  Completed = 3,
  Postponed = 4,
  Canceled = 5,
  Delayed = 6
}

export enum RolesEnum {
  Admin = 'Admin',
  GeneralManager = "GeneralManager",
  PartnershipsManager = "PartnershipsManager"
}

export enum RecordStatusEnum {
  Active = 1,
  Finished = 2,
  Canceled = 3
}
export enum PermitStatusEnum {
  UnderPreparation = 1,
  UnderFinalReview = 2,
  Approved = 3,
  Rejected = 4
}

export enum RequestStatusEnum {
  Draft = 1,
  Approved = 2,
  Rejected = 3,
  WaitingResubmit = 4,
  Waiting = 5,
  Canceled = 6,
}

export enum CampaignStatusEnum {
  Active = "Active",
  Completed = "Completed",
  PermitInprogress = "PermitInprogress",
  Canceled = "Canceled"
}

export enum AgreementStatusEnum {
  Draft = 1,
  Active = 2,
  Waiting = 3,
  Canceled = 4,
  Completed = 5,
  Rejected = 6
}
export enum ProcessActivityEnum {
  //ChangeAgent_Approver1_Review = 1,
  //ChangeAgent_Submitter_Review = 2,
}
export enum ItemLogType {
   Permit = 2,
  Agreement = 1,
   Task = 3,
  Event = 4,
  Initiative = 5,
  Campaign = 6
}
